import { IconButton, TextField } from '@material-ui/core';
import { SearchIcon } from 'components/Icons';
import LayoutContext from 'components/Layout/LayoutContext';
import Loading from 'components/Loading';
import PageTitle from 'components/PageTitle/PageTitle';
import Page from 'components/PrivateContainer';
import UnauthorizedScreen from 'components/UnauthorizedScreen/UnauthorizedScreen';
import { EfetivacaoVotacaoPath } from 'library/Routes';
import { AssembleiaContaAssessor } from 'models/AssembleiaContaAssessor';
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { assembleiasAssessorActionsLoadContasCanalVoz } from 'store/modules/AssembleiasAssessorActions';
import { IAuthReducer } from 'store/modules/AuthReducer';
import { IReducer } from 'store/Reducer';
import { history } from 'store/Store';
import AxiosErrorHandler from 'utils/AxiosErrorHandler';
import { clearFormat, formatCPFOrCNPJ } from 'utils/cpfCnpjMask';
import { getToastError } from 'utils/ToasterUtils';
import useStyle from './style';

// interface PageState {
//   lastVote?: string;
// }
interface RouteParams {
  idAssembleia: string;
}

export default function () {
  const {t} = useTranslation();
  const classes = useStyle();
  // const location = useLocation<PageState | undefined>();
  const auth = useSelector<IReducer, IAuthReducer>(state => state.auth);
  const [touched, setTouched] = useState<boolean>(false);
  const [currentCpf, setCurrentCPF] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { idAssembleia } = useParams<RouteParams>();
  const { setToolbarReadOnly } = useContext(LayoutContext);

  const dispatch = useDispatch();

  const formError = useMemo(() => {
    const cpf = clearFormat(currentCpf);
    if (touched && cpf.length === 0) return 'canalVoz.error.obrigatorio';
    // console.log(cpf.length === 11, location.state, location.state?.lastVote, cpf === location.state?.lastVote)
    // if (cpf.length === 11 && location.state?.lastVote && cpf === location.state.lastVote) {
    if (touched && cpf.length !== 11) {
      return 'canalVoz.error.invalido';
    }
    return '';
  }, [currentCpf, touched]);

  const handleSubmit = useCallback(
    async (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      if (formError.length > 0) return;
      setIsLoading(true);

      dispatch(
        assembleiasAssessorActionsLoadContasCanalVoz(
          parseInt(idAssembleia),
          currentCpf,
          (data: AssembleiaContaAssessor[]) => {
            setIsLoading(false);
            if (data) {
              const path = EfetivacaoVotacaoPath
              .replace(':idAssembleia', idAssembleia)
              .replace(':cpfRepresentante', btoa(currentCpf));
              if (data.filter(it => it.presente).length === 0) {
                getToastError(t(`canalVoz.semPresencas`))
              } else {
                history.push(path);
              }
            }
          },
          error => {
            setIsLoading(false);
            AxiosErrorHandler(error);
          }
        )
      );
    },
    [t, dispatch, currentCpf, idAssembleia, formError]
  );

  useEffect(() => {
    setToolbarReadOnly(true);
  }, [setToolbarReadOnly]);

  if (!auth.usuario?.perfil.assessorRoute.assembleias.pautas.incluirVotoManual) {
    return <UnauthorizedScreen />;
  }

  return isLoading ? (
    <Loading />
  ) : (
    <Page
      header={
        <React.Fragment>
          <PageTitle title={t('canalVoz.titleHead')} className={classes.mainTitle} />
        </React.Fragment>
      }
    >
      <form onSubmit={handleSubmit}>
        <TextField
          label={t('canalVoz.cpf')}
          className={classes.input}
          InputProps={{
            endAdornment: (
              <IconButton type="submit" className={classes.clearIcon} disabled={formError.length > 0}>
                <SearchIcon className={classes.searchIcon} />
              </IconButton>
            ),
          }}
          value={formatCPFOrCNPJ(currentCpf, true)}
          onChange={e => {
            setCurrentCPF(clearFormat(e.currentTarget.value, true))
          }}
          onBlur={() => setTouched(true)}
          error={formError.length > 0}
          helperText={formError.length > 0 ? t(formError) : undefined}
          required
          fullWidth
        />
      </form>
    </Page>
  );
}
